export default {
	width: 40,
	lineHeight: 4,
	lineSpacing: 6,
	color: '#000',
	borderRadius: 0,
	active: false,
	padding: '15px',
}